// extracted by mini-css-extract-plugin
export default {"section":"pendingReports_section__Xw2MN","li":"pendingReports_li__eRyt6","btn":"pendingReports_btn__9mDUk"};